import React, { useEffect } from 'react';
import { Box, Button, Card, CardContent, Container, Divider, Typography } from '@mui/material';
import Logo from '../components/layout/Logo';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../redux/store';
import { userRecoverTOTP } from '../redux/slices/user';

const TotpRecovery = () => {
	const { token } = useParams();
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (!token) return;

		dispatch(userRecoverTOTP(token));
	});

	return (
		<Container>
			<Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Card>
					<CardContent sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
						<Box display={'flex'} justifyContent={'center'}>
							<Logo />
						</Box>
						<Typography variant="h6">Multi-Factor Authentication Recovery</Typography>
						<Divider />
						<Typography>
							Please
							<Button onClick={() => navigate('/login')}>Login</Button>
							and set up your new multi-factor authentication code.
						</Typography>
					</CardContent>
				</Card>
			</Box>
		</Container>
	);
};

export default TotpRecovery;
